import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EventCountdown from "../components/EventCountdown";
import EventSection from "../components/EventSection";
import RegistrationSection from "../components/RegistrationSection";
import JurySection from "../components/JurySection";
import SpecialMentions from "../components/SpecialMentions"; 
import RankingArena from "../components/RankingArena";
import AboutSection from "../components/AboutSection";
import Footer from "../components/Footer";
import { useEffect } from "react";
import { toast } from "sonner";

export default function HomePage() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "cancelled") {
      toast.error("Pagamento annullato. Puoi riprovare quando vuoi.");
      window.history.replaceState({}, "", "/");
    }
  }, []);

  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <EventCountdown /> 
      <EventSection />

      {/* LA SFIDA DEL CAMPIONE COME VALORE AGGIUNTO PRIMA DI ISCRIVERSI */}
      <SpecialMentions /> 
      
      <RegistrationSection />
      
      <JurySection />
      <RankingArena />
      
      <AboutSection /> 
      
      <Footer />
    </main>
  );
}